const TYPE_INVENTORY = 1;
const TYPE_COMPOSITE = 0;

module.exports = function(h, row) {
    if (row.track_stock === null || row.track_stock == 0) {
        return <i class="text-muted">Not Tracked</i>;
    }

    if (_.isNull(row.inventory_type) || row.inventory_type == TYPE_INVENTORY) {
        return 'Component';
    }

    if (row.inventory_type == TYPE_COMPOSITE) {
        return 'End Product';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/columns/inventory_type.jsx